export default __webpack_public_path__ + "static/twitch-to-tiktok-7d7652562fa9bbc2307c283101bd9961.mp4";